export const LIST_HEADERS = [
  "alert_name",
  "alert_type",
  "alert_level",
  "name",
  "serial",
  "site_name",
  "location_name",
  "state",
  "alarm",
];
